import { render, staticRenderFns } from "./SaldoPrincipal.vue?vue&type=template&id=9857bc44&scoped=true&"
import script from "./SaldoPrincipal.vue?vue&type=script&lang=js&"
export * from "./SaldoPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./SaldoPrincipal.vue?vue&type=style&index=0&id=9857bc44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9857bc44",
  null
  
)

export default component.exports